import Icon from '../components/Icon.vue'

Icon.register({
  bicycle: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M512.5 192c71 0.3 128.6 59.1 127.5 130-1.1 70.2-58.6 126.7-129.3 126-68.8-0.7-126.6-58.9-126.7-127.7-0.1-37.4 15.9-71 41.3-94.4l-14.9-24.1-86 138.9c-3.9 6.3-13 11.4-20.4 11.4h-52c-14.2 55.2-64.3 96-124 96-70.9 0-128.4-57.7-128-128.8 0.4-70.2 58.1-127.4 128.3-127.2 15.1 0 29.6 2.7 43 7.5l29.4-47.5h-48.7c-13.1 0-23.8-10.5-24-23.6-0.2-13.4 11.1-24.4 24.5-24.4h87.5c8.8 0 16 7.2 16 16v16h113.5l-14.9-24h-50.6c-8.8 0-16-7.2-16-16v-16c0-8.8 7.2-16 16-16h64 0c7.4 0 16.5 5.1 20.4 11.3l77.7 125.2c14.4-5.5 30.1-8.6 46.4-8.5zM186.8 265.8l-23.7 38.2h43.3c-3-14.6-9.9-27.7-19.6-38.2zM128 400c32.7 0 60.9-19.8 73.3-48h-81.3c-18.8 0-30.3-20.7-20.4-36.6l45.5-73.5c-5.5-1.2-11.2-1.9-17.1-1.9-44.1 0-80 35.9-80 80s35.9 80 80 80zM290.6 304l74.3-120h-127.5l-24.7 40c22.8 20.1 38.4 48.3 42.4 80h35.6zM507.7 399.9c46.1 2.4 84.3-34.3 84.3-79.9 0-44.1-35.9-80-80-80h0c-5.6 0-14.4 1.1-19.8 2.5l44.5 71.6c4.7 7.5 2.4 17.4-5.2 22l-13.6 8.4c-7.5 4.7-17.4 2.4-22-5.2l-44.4-71.6c-12.7 14.7-20.1 34.1-19.3 55.3 1.6 41.1 34.6 74.6 75.6 76.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bicycle.js
// module id = 663
// module chunks = 0